import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { UpdateBanner } from './UpdateBanner.js';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // §11: keine gecachten Wäschezustände über die Sitzung hinaus. Beim Wiedereinstieg
      // wird neu geladen — lieber ein Ladebalken als ein falsches "ist sauber".
      staleTime: 15_000,
      gcTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

const root = document.getElementById('root');
if (root === null) throw new Error('#root fehlt im Dokument');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <UpdateBanner />
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
